import React, { FC } from 'react'
import { Row, Col, Form, Card, Button } from 'react-bootstrap'
import { Formik } from 'formik'
import { DisclosureQuestionsSchema } from '../../../../utils/validation'

interface Props {
  initialValues: any;
  readonly: boolean;
  handleBack: (values: any) => void;
  onSubmit: (values: any, submitItem: boolean) => void;
}

const DisclosureQuestions: FC<Props> = ({ initialValues, readonly, handleBack, onSubmit }: Props) => {
  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={DisclosureQuestionsSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, true)
          setSubmitting(false)
        }}
      >
        {({ errors, values, handleChange, handleSubmit, setFieldValue, dirty, isValid }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Card>
              <Card.Body style={{ background: '#f7f7f7' }}>
                <Card.Title>Disclosure Questions</Card.Title>
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 1</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value='Has the licensure or certification (if applicable) ever been terminated, stipulated, restricted, limited, conditioned, suspended, revoked refused, voluntarily reliquished, or not renewed by any licensing/certifying agency or any agency or organization, or is there a review pending?'
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion1 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion1', 'YES')}
                        isInvalid={!!errors.disclosureQuestion1}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion1 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion1', 'NO')}
                        isInvalid={!!errors.disclosureQuestion1}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion1 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion1}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion1 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion1Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion1Explanation}
                          isInvalid={!!errors.disclosureQuestion1Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion1Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 2</Form.Label>
                    <Form.Control 
                      as='textarea'
                      value='Has participation (if applicable) in any professional organization ever been voluntarily or in voluntarily denied, terminated, restricted, limited, suspended or revoked?'
                      disabled
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion2 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion2', 'YES')}
                        isInvalid={!!errors.disclosureQuestion2}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion2 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion2', 'NO')}
                        isInvalid={!!errors.disclosureQuestion2}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion2 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion2}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion2 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion2Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion2Explanation}
                          isInvalid={!!errors.disclosureQuestion2Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion2Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 3</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value='Have you ever been reprimanded, censored, or otherwise disciplined by, or have you ever been subject to a corrective action plan with any licensing board, peer review organization, state agency, county agency, or any provider related agency or organization?'
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion3 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion3', 'YES')}
                        isInvalid={!!errors.disclosureQuestion3}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion3 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion3', 'NO')}
                        isInvalid={!!errors.disclosureQuestion3}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion3 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion3}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion3 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion3Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion3Explanation}
                          isInvalid={!!errors.disclosureQuestion3Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion3Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 4</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value='Has your certification or participation in any private, federal (e.g. Medicare, Medicaid) or state health insurance program ever been revoked or otherwise limited or restricted, or is any investigation or proceeding with respect to any such action presently underway?'
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion4 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion4', 'YES')}
                        isInvalid={!!errors.disclosureQuestion4}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion4 === 'NO'}
                        isInvalid={!!errors.disclosureQuestion4}
                        onChange={() => setFieldValue('disclosureQuestion4', 'NO')}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion4 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion4}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion4 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion4Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion4Explanation}
                          isInvalid={!!errors.disclosureQuestion4Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion4Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 5</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value='Have you ever been found liable, guilty or responsible for sexual impropriety or misconduct or sexual harassment with a client, co-worker or other?'
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion5 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion5', 'YES')}
                        isInvalid={!!errors.disclosureQuestion5}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion5 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion5', 'NO')}
                        isInvalid={!!errors.disclosureQuestion5}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion5 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion5}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion5 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion5Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion5Explanation}
                          isInvalid={!!errors.disclosureQuestion5Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion5Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 6</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value='Have you ever had any liability claims or lawsuits brought against you, including pending claims or lawsuits, dismissed or dropped claims or dropped claims or lawsuits, settlements or final judgments?'
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion6 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion6', 'YES')}
                        isInvalid={!!errors.disclosureQuestion6}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion6 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion6', 'NO')}
                        isInvalid={!!errors.disclosureQuestion6}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion6 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion6}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion6 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion6Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion6Explanation}
                          isInvalid={!!errors.disclosureQuestion6Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion6Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
                <Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Question 7</Form.Label>
                    <Form.Control 
                      as='textarea'
                      disabled
                      value={'Do you have a physical or mental condition that would affect your ability, with or without reasonable accommodation, to provide appropriate care to clients and otherwise perform the essential functions of a provider in your area of service provision? \n\nIf yes, what accommodations would help you provide appropriate care to clients and perform other essential functions?'}
                      rows={4}
                    />
                  </Form.Group>
                  <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Answer</Form.Label>
                    <div>
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='YES'
                        checked={values.disclosureQuestion7 === 'YES'}
                        onChange={() => setFieldValue('disclosureQuestion7', 'YES')}
                        isInvalid={!!errors.disclosureQuestion7}
                        disabled={readonly}
                      />
                      <Form.Check 
                        type='checkbox'
                        inline
                        label='NO'
                        checked={values.disclosureQuestion7 === 'NO'}
                        onChange={() => setFieldValue('disclosureQuestion7', 'NO')}
                        isInvalid={!!errors.disclosureQuestion7}
                        disabled={readonly}
                      />
                    </div>
                    { 
                      errors.disclosureQuestion7 && (
                        <Form.Text className="form-error">
                          {errors.disclosureQuestion7}
                        </Form.Text>
                      )
                    }
                  </Form.Group>
                  {
                    values.disclosureQuestion7 === 'YES' ? (
                      <Form.Group as={Col} xs={12}>
                        <Form.Label>Explanation</Form.Label>
                        <Form.Control 
                          as='textarea'
                          rows={4}
                          name='disclosureQuestion7Explanation'
                          placeholder='Please provide a complete explanation.'
                          value={values.disclosureQuestion7Explanation}
                          isInvalid={!!errors.disclosureQuestion7Explanation}
                          onChange={handleChange}
                          disabled={readonly}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.disclosureQuestion7Explanation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : null
                  }
                </Row>
                <hr />
              </Card.Body>
            </Card>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
              {
                !readonly ? (
                  <Button
                    variant='secondary'
                    style={{ width: '115px'}}
                    onClick={() => onSubmit(values, false)}
                  >
                    Save & Exit
                  </Button>
                ) : null
              }
              <div>
                <Button
                  variant='secondary'
                  style={{ width: '115px', marginRight: 10 }}
                  onClick={() => handleBack(values)}
                >
                  Previous
                </Button>
                {
                  !readonly ? (
                    <Button
                      variant='info'
                      style={{ width: '115px', marginRight: 10 }}
                      type='submit'
                      disabled={!isValid}
                    >
                      Submit
                    </Button>
                  ) : null
                }
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default DisclosureQuestions